import React, { useState } from "react";
import { FiImage } from "react-icons/fi";

const PLACEHOLDER = "/images/product-placeholder.svg";

// All product image surfaces share the existing sizing, loading and fallback.
export default function ProductImage({ image, eager = false, decoding = "async", className = "", decorative = false, onLoad }) {
  const [failedSrc, setFailedSrc] = useState(null);
  const failed = failedSrc === image.src;
  const isPlaceholder = failed || image.src === PLACEHOLDER;
  return (
    <div className={`product-image-wrap${isPlaceholder ? " is-placeholder" : ""}${className ? ` ${className}` : ""}`} aria-hidden={decorative ? true : undefined}>
      <img className="product-image"
        src={failed ? PLACEHOLDER : image.src}
        alt={decorative ? "" : failed ? "Product image coming soon" : image.alt}
        width="640" height="480" loading={eager ? "eager" : "lazy"} decoding={decoding}
        onLoad={onLoad} onError={failed ? undefined : () => setFailedSrc(image.src)} />
      {isPlaceholder && <span className="product-placeholder-caption" aria-hidden="true"><FiImage />Product image coming soon</span>}
    </div>
  );
}
